// extracted by mini-css-extract-plugin
export default {"main":"_894cd90962 b72cd39705","xmark":"_7b4cd46bc4","fl_img":"_2e8c60bc16 _7b451fa49c"};